export default {
  fzjn: "资料",
  fzda: "服装档案",
  fzpc: "评测",
  djmb: "面板",
  ydl: "阅读量",
  dz: "点赞",
  sc: "收藏",
  pl: "评论",
  fx: "分享",
  fhsy: "返回",
  xzjs: "切换",
  fzlh: "服装立绘",
  lhxz: "立绘下载",
  lh: "立绘",
  dt: "大图",
  xt: "小图",
  gscg: "故事CG",
  hgddh: "好感度动画",
  jndh: "技能动画",
  gjswttf: "该角色暂无天赋",
  qhszdb: "强化数值对比",
  jnql: "技能潜力",
  jn: "技能",
  sz: {
    qh: "强化",
    xh: "消耗",
    lqsj: "冷却时间",
    jnfw: "技能范围",
    jnxg: "技能效果",
    hh: "回合"
  },
  daxx: "档案信息",
  jsyy: "角色语音",

  cqjy: "抽取建议",
  qdfx: "强度分析",
  hjfx: "环境分析",
  zrdp: "阵容搭配",
  ckgd: "查看更多",
  xppc: "XP评测",
  jsmt: "角色美图",
  xct: "宣传图",
  jsda: "角色档案",
  srht: "生日贺图",
  ect: "二创图",
  ssxfzzsxxpc: "三四星服装暂无详细评测",
  xggxfdwzbpcb: "先逛逛下方的文字版评测吧",
  xggxfdzhpcb: "先逛逛下方的综合评测吧",
  ssxfzpc: "三四星服装评测",
  sx: "属性",
  dqsz: "当前数值",
  fctzjpb: "副词条最佳配比",
  qhfz: "切换服装",
  qhbdfz: "切换绑定服装",
  ky: "刻印",
  jx: "觉醒",
  zcjsy: "珍藏集收益",
  fzgynlz: "服装共用能力值",
  fzbdnlz: "服装绑定能力值",
  hydjsj: "还原顶级数据",

  tf: "天赋",
  tfqhxg: "天赋强化效果",
  gjszwtf: "该角色暂无天赋",
  jsxx: "角色信息",
  zjtj: "最佳推荐",
  xwtb: "下位替补",
  jnsm: "技能说明",
  jnfw: "技能范围",
  zzjzzo: "正在加载中哦",
  zlzskqlyrbzjj: "资料暂时空缺，留言让版主加急",
  gjsxydlhcngko: "该角色需要登录后才能观看哦~",
  dl: "登录",
  gjsxsmrzhcngko: "该角色需实名认证后才能观看哦~",
  smrz: "实名认证",
  ndsmxxwwcnrbfnrwfll: "您的实名信息为未成年人，部分内容无法浏览",
  tt: "推图",
  hjzwtjzr: "环境暂无推荐阵容",
  bhhxh: "本回合消耗",
  chjqszd: "（此环境）起始战斗",
  zjsysp: "增加/剩余SP",
  xhsp: "消耗SP",
  spbjbj: "SP不加不减",
  spsywf: "SP剩余为负",
  spszzdtzsyjnssxdds: "SP是在战斗途中使用技能时所需的点数",
  mhhjssfhfsojnsxyhhzsphhfbfsp: "某回合，角色释放【恢复SP】技能时；下一回合总SP会恢复部分SP",
  mhhjsgjhjtsxyhhzsphhf1sp: "某回合，角色【攻击或击退】时；下一回合总SP会恢复1SP",

  qsrxydzbmc: "请输入需要的装备名称",
  zyzb: "专用装备",
  zzzb: "制作装备",
  mszb: "魔兽装备",
  jbnl: "基本能力",
  xxnl: "选项能力",
  zynl: "专用能力",
  zb: "装备",
  cq: "抽取",
  gl: "概率",
  sj: "随机",
  x: "选",
  dj: "等级",
  yb: "一般",
  gj: "高级",
  zgj: "最高级",
  cs: "传说",
  scpzy: "收藏品增益",
  xqcl: "需求材料",
  jbnlms1: "会随机赋予基本能力2中的一个<br/>每个选项的概率都相同",
  xxnlms1:
    "达成3/6/9时，会随机赋予：生命力（N）/ 生命力（%）/ 攻击力（N）/ 攻击力（%）/ 致命率（%）/ 致命伤害（%）/ 防御力（%）/ 魔法抵抗（%）等选填中的一个，每个选项的概率都相同",
  xxnlms2:
    "达成3/6/9时，会随机赋予：生命力（N）/ 生命力（%）/ 攻击力（N）/ 攻击力（%）/ 魔法力（N）/ 魔法力（%）/ 致命率（%）/ 致命伤害（%）/ 防御力（%）/ 魔法抵抗（%）等选填中的一个，每个选项的概率都相同",

  shengxing: "升星",
  qh: "强化",
  jt: "击退",
  gongji: "攻击",
  wfzd: "无法战斗",

  专用: "专用",
  制作: "制作",
  魔兽: "魔兽",

  武器: "武器",
  盔甲: "盔甲",
  头盔: "头盔",
  饰品: "饰品",
  手套: "手套",

  生命力: "生命力",
  攻击力: "攻击力",
  魔法力: "魔法力",
  致命率: "致命率",
  致命伤害: "致命伤害",
  防御力: "防御力",
  魔法抵抗: "魔法抵抗",
  火属性伤害: "火属性伤害",
  风属性伤害: "风属性伤害",
  水属性伤害: "水属性伤害",
  光属性伤害: "光属性伤害",
  暗属性伤害: "暗属性伤害",
  火属性抵抗: "火属性抵抗",
  风属性抵抗: "风属性抵抗",
  水属性抵抗: "水属性抵抗",
  属性抵抗: "属性抵抗"
};
